// features/profile/profileSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileData {
  firstName: string;
  lastName: string;
  phone: string;
  companyName: string;
  companyType: string;
  website: string;
  country: string;
  city: string;
  address: string;
  postalCode: string;
  profilePhoto: string;
}

const initialState: ProfileData = {
  firstName: 'NA',
  lastName: 'NA',
  phone: '96586 62568',
  companyName: 'Triaxa FZCO',
  companyType: 'News',
  website: 'https://www.triaxa.com',
  country: 'USA',
  city: 'Washington, D.C.',
  address: '1723 Constitution Ave NW',
  postalCode: '20006',
  profilePhoto: require('../../assets/placeholderprofile.png'), // Default placeholder
};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateProfile: (state, action: PayloadAction<ProfileData>) => {
      return { ...state, ...action.payload }; // Merge updated data into state
    },
  },
});

export const { updateProfile } = profileSlice.actions;
export default profileSlice.reducer;
